import { Labels } from '../../shared-components/global/labels';

Labels.set('validation', 'input', 'Введите, пожалуйста, верные данные.');
Labels.set('validation', 'date', 'Введите, пожалуйста, верные данные.');
Labels.set('validation', 'time', 'Укажите, пожалуйста, время.');
Labels.set('validation', 'range', 'Данные указаны неверно.');
Labels.set('validation', 'month', 'Укажите, пожалуйста, месяц.');
Labels.set(
    'validation',
    'datetime-local',
    'Укажите, пожалуйста, дату и время.'
);
Labels.set(
    'validation',
    'custom',
    'Ошибка. Проверьте, пожалуйста, введённые данные.'
);
Labels.set('validation', 'pattern', 'Укажите в правильном формате.');
Labels.set(
    'validation',
    'rangeOverflow',
    'Значение должно быть равно или меньше %s.'
);
Labels.set(
    'validation',
    'rangeUnderflow',
    'Значение должно быть равно или больше %s.'
);
Labels.set(
    'validation',
    'step',
    'Шаг должен составлять %s, ближайшие значения – %s и %s'
);
Labels.set(
    'validation',
    'long',
    'Слишком большое значение, максимальное количество символов – %s  '
);
Labels.set(
    'validation',
    'short',
    'Слишком маленькое значение, минимальное количество символов – %s  '
);
Labels.set('validation', 'type', 'Введите, пожалуйста, верные данные.');
Labels.set('validation', 'email', 'Введите, пожалуйста, адрес э-почты.');
Labels.set('validation', 'url', 'Введите, пожалуйста, URL-адрес.');
Labels.set('validation', 'value', 'Заполните, пожалуйста, это поле.');

// User defined rule validations
Labels.set('validation', 'matches', 'Данные полей не совпадают.');
Labels.set(
    'validation',
    'checkboxes',
    'Выберите, пожалуйста, хотя бы %s вариант(а/ов).'
);
Labels.set('validation', 'remote', 'Ошибка сервера');
Labels.set('validation', 'maxfilesize', 'Размер файла(-ов) больше чем %s Kb.');
Labels.set(
    'validation',
    'requiredMultiple',
    'Заполните, пожалуйста, хотя бы %s вариант(а/ов).'
);

// Example formats for pattern rule
Labels.set('validation', 'basicDateFormat', 'DD.MM.YYYY');
Labels.set(
    'validation',
    'alternativeDateFormat',
    'DD.MM.YYYY или D.M.YYYY или D.MM.YYYY'
);
Labels.set('validation', 'reverseDateFormat', 'YYYY.MM.DD');
Labels.set('validation', 'basicTimeFormat', 'HH:MM:SS');
Labels.set('validation', 'shortTimeFormat', 'HH:MM');
Labels.set('validation', 'digitsAmountFormat', '%s цифр.');
Labels.set('validation', 'digitsAmountHardcodedFormat', '13–16 цифр');
Labels.set('validation', 'lettersAndNumbersFormat', 'Буквы и цифры.');
Labels.set('validation', 'lettersOnlyFormat', 'Только буквы.');
Labels.set('validation', 'numbersOnlyFormat', 'Только цифры.');
Labels.set(
    'validation',
    'decimalPointNumbersFormat',
    'Числа с десятичными знаками, например 9.99 или 9,99.'
);
Labels.set(
    'validation',
    'startingDateBeforeEndingDate',
    'Дата начала должна быть раньше даты окончания.'
);
